import axios from 'axios'
import { platform } from '@pay24/common'

export function base64ToBlob(
  base64: string,
  contentType = '',
  sliceSize = 512,
) {
  const base64_split = base64.split(',')
  const byteCharacters = atob(base64_split[base64_split.length - 1])
  const byteArrays: Uint8Array[] = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)
    const byteNumbers = new Array(slice.length)

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  return new Blob(byteArrays, { type: contentType })
}

export const validator = (value: string) => {
  if (value === '00') return '0.0'
  if (value === '.' || value === ',') return '0.'
  const [left = '', right = ''] = value.split('.')
  return [
    left.substring(0, 9),
    value.includes('.') || value.includes(',') ? '.' : '',
    right.substring(0, 2),
  ]
    .filter(Boolean)
    .join('')
    .replace(/[^0-9.]/g, '')
}

export function errorString(error: any) {
  return `${
    typeof error === 'string'
      ? error
      : !axios.isAxiosError(error)
      ? error.message || error
      : error.response?.data.message ||
        error.response?.statusText ||
        error.message ||
        error
  }`
}

export const getAppDomain = () => {
  const base_url = platform.erp.url
  if (base_url.includes('ingo')) return 'ingosstrah'
}
